/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_DescriptionInputs */

const id_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah gambar avatar baru, maks 5MB.`)
};

const ms_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat naik imej avatar baharu, maks 5MB.`)
};

const da_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload et nyt avatar-billede, max 5MB.`)
};

const de_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie ein neues Avatar-Bild hoch, max. 5 MB.`)
};

const en_us2_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a new avatar image, max 5MB.`)
};

const es_es2_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube una nueva imagen de avatar, máximo 5MB.`)
};

const es_mx2_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube una nueva imagen de avatar, máximo 5 MB.`)
};

const fil_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-upload ng bagong avatar image, max 5MB.`)
};

const fr_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversez une nouvelle image d'avatar, max 5 Mo.`)
};

const it_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica una nuova immagine avatar, max 5MB.`)
};

const hu_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tölts fel egy új avatar képet, max 5MB.`)
};

const nl_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload een nieuwe avatarafbeelding, max 5MB.`)
};

const no_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last opp et nytt avatarbilde, maks 5 MB.`)
};

const pl_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prześlij nowy obraz awatara, maks. 5MB.`)
};

const pt_br2_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça upload de uma nova imagem de avatar, com no máximo 5 MB.`)
};

const pt_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregue uma nova imagem de avatar, máx. 5MB.`)
};

const ro_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încarcă o nouă imagine de avatar, max 5MB.`)
};

const fi_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa uusi avatar-kuva, enintään 5 Mt.`)
};

const sv_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp en ny avatar-bild, max 5 MB.`)
};

const vi_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lên ảnh đại diện mới, tối đa 5MB.`)
};

const tr_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni bir avatar görseli yükleyin, maksimum 5MB.`)
};

const cs_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrajte nový obrázek avataru, max 5 MB.`)
};

const bg_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Качете ново аватар изображение, макс. 5MB.`)
};

const ru_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите новое изображение аватара, максимальный размер файла 5 МБ.`)
};

const uk_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажте нове зображення аватара, макс. 5 МБ.`)
};

const ar_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل صورة رمزية جديدة، الحد الأقصى 5 ميجابايت.`)
};

const hi_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक नई अवतार छवि अपलोड करें, अधिकतम 5MB।`)
};

const th_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปโหลดรูปโปรไฟล์ใหม่ สูงสุด 5MB`)
};

const ja_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいアバター画像をアップロード（最大5MB）。`)
};

const zh_cn2_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传新的头像图片，最大5MB。`)
};

const zh_hant1_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上傳新的大頭貼圖片，最大5MB。`)
};

const ko_profile_avatar_description = /** @type {(inputs: Profile_Avatar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 아바타 이미지를 업로드하세요. 최대 5MB입니다.`)
};

/**
* | output |
* | --- |
* | "Upload a new avatar image, max 5MB." |
*
* @param {Profile_Avatar_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_description = /** @type {((inputs?: Profile_Avatar_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_description(inputs)
	if (locale === "ms") return ms_profile_avatar_description(inputs)
	if (locale === "da") return da_profile_avatar_description(inputs)
	if (locale === "de") return de_profile_avatar_description(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_description(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_description(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_description(inputs)
	if (locale === "fil") return fil_profile_avatar_description(inputs)
	if (locale === "fr") return fr_profile_avatar_description(inputs)
	if (locale === "it") return it_profile_avatar_description(inputs)
	if (locale === "hu") return hu_profile_avatar_description(inputs)
	if (locale === "nl") return nl_profile_avatar_description(inputs)
	if (locale === "no") return no_profile_avatar_description(inputs)
	if (locale === "pl") return pl_profile_avatar_description(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_description(inputs)
	if (locale === "pt") return pt_profile_avatar_description(inputs)
	if (locale === "ro") return ro_profile_avatar_description(inputs)
	if (locale === "fi") return fi_profile_avatar_description(inputs)
	if (locale === "sv") return sv_profile_avatar_description(inputs)
	if (locale === "vi") return vi_profile_avatar_description(inputs)
	if (locale === "tr") return tr_profile_avatar_description(inputs)
	if (locale === "cs") return cs_profile_avatar_description(inputs)
	if (locale === "bg") return bg_profile_avatar_description(inputs)
	if (locale === "ru") return ru_profile_avatar_description(inputs)
	if (locale === "uk") return uk_profile_avatar_description(inputs)
	if (locale === "ar") return ar_profile_avatar_description(inputs)
	if (locale === "hi") return hi_profile_avatar_description(inputs)
	if (locale === "th") return th_profile_avatar_description(inputs)
	if (locale === "ja") return ja_profile_avatar_description(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_description(inputs)
	return ko_profile_avatar_description(inputs)
});
export { profile_avatar_description as "profile.avatar.description" }